/**
 * export namespace
 */
export const NAMESPACE = 'DISCONNECT';
/**
 * DISCONNECT_WEBCHAT_MESSAGE
 */
export const DISCONNECT_WEBCHAT = `webchat/${NAMESPACE}/DISCONNECT_WEBCHAT_MESSAGE`;

/**
 * DISCONNECT_WEBCHAT_MESSAGE_SUCCESS
 */
export const DISCONNECT_WEBCHAT_SUCCESS = `webchat/${NAMESPACE}/DISCONNECT_WEBCHAT_MESSAGE_SUCCESS`;

/**
 * DISCONNECT_WEBCHAT_MESSAGE_FAILED
 */
export const DISCONNECT_WEBCHAT_FAILED = `webchat/${NAMESPACE}/DISCONNECT_WEBCHAT_MESSAGE_FAILED`;
